// extracted by mini-css-extract-plugin
module.exports = {"transparent":"Button_transparent__zDr8i","primary":"Button_primary__9WYQ9","button_icon":"Button_button_icon__6__4z","button":"Button_button__zs_j1"};